import { Permission } from '@aid/shared';

export function hasGlobalPaymentAccess(permissions: readonly string[]): boolean {
  return permissions.includes(Permission.PAGOS_ANULAR);
}

export function hasCobradorPaymentScope(permissions: readonly string[]): boolean {
  return permissions.includes(Permission.COBRADOR_READ) && !hasGlobalPaymentAccess(permissions);
}
